import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import FrameworkContractsAddArticleModal from "./FrameworkContractsAddArticleModal";

export default class FrameworkContractsAddArticle extends Component {
    constructor() {
        super();

        this.state = {
            show_modal: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({show_modal: true});
    }

    closeModal() {
        this.setState({show_modal: false});
    }

    render() {
        return (
            <div>
                <Button onClick={this.openModal}
                        bsStyle="primary">
                    <i className="fa fa-plus"></i> {window.__js_contracts.add_article}
                </Button>
                <FrameworkContractsAddArticleModal
                    id={this.props.framework_contract_id}
                    showModal={this.state.show_modal}
                    closeCallback={this.closeModal}/>
            </div>
        );
    }
}

if (document.getElementById("framework-contracts-add-article")) {
    let element = document.getElementById("framework-contracts-add-article");
    let csrf_token = element.getAttribute("data-csrf-token");
    let framework_contract_id = element.getAttribute("data-framework-contract-id");

    ReactDOM.render(
        <FrameworkContractsAddArticle
            csrfToken={csrf_token}
            framework_contract_id={framework_contract_id}/>,
        element
    );
}